.message-bar {
  margin: 10px 0;
  .button {
    font-size: 12px;
  }
}
